import './App.scss';
import 'bootstrap/dist/css/bootstrap.css';
import Router from './router/Router';
import Header from './components/header/header';
import Footer from './components/footer/footer';
// import Loading from './components/loading/loading';
import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import ScrollTop from './components/scrollTop/scrollTop';
import SidebarLeft from './components/sidebarLeft/sidebarLeft';
import { initializeLanguageFromAPI } from './language/initializeLanguage';
import { useTranslation } from 'react-i18next';

function App() {

  // const [loading, setLoading] = useState(true);
  const [scrollValue, setScrollValue] = useState("");
  const [isChangingLang, setIsChangingLang] = useState(false);
  const { i18n } = useTranslation();
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  // Khởi tạo ngôn ngữ mặc định từ API khi component mount
  useEffect(() => {
    initializeLanguageFromAPI();
  }, []);

  // Fade animation khi đổi ngôn ngữ
  useEffect(() => {
    const handleLanguageChanged = () => {
      setIsChangingLang(true);
      setTimeout(() => setIsChangingLang(false), 300);
    };
    i18n.on('languageChanged', handleLanguageChanged);
    return () => i18n.off('languageChanged', handleLanguageChanged);
  }, [i18n]);

  const handleScroll = (event) => {
    const scrollTop = event.target.documentElement.scrollTop;
    setScrollValue(scrollTop);
  }
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    // return window.removeEventListener("scroll",handleScroll);
  }, [scrollValue])

  if (isAdminRoute) {
    return (
      <div className="admin-app">
        <Router />
      </div>
    );
  }

  return (
    <div className="App">
      {/* {loading 
      ?  <div className='loadding-fullcreen'>
          {loading ? <Loading /> : ""}
        </div> 
      : ""
      } */}
      <ScrollTop scrollValue={scrollValue} />
      {/* <SidebarLeft /> */}
      <Header
        scrollValue={scrollValue}
      />

      <main className={`main${isChangingLang ? ' lang-fade' : ''} ${!isAdminRoute && location.pathname !== '/' && location.pathname !== '/home' && location.pathname !== '/trang-chu' ? 'page-mint-theme' : ''}`}>
        <Router />
      </main>
      <Footer />
    </div>
  );
}

export default App;
